const middleware = {}

middleware['content-fetch'] = require('../middleware/content-fetch.js')
middleware['content-fetch'] = middleware['content-fetch'].default || middleware['content-fetch']

export default middleware
